<template>
    <button class="link-button" :class="color">
        <slot />
    </button>
</template>
<script setup>
defineProps({
    color: {
        type: String,
        required: false,
    },
});
</script>
<style lang="scss" scoped>
@use '@/scss/variables' as vars;

.link-button {
    background-color: transparent;
    border: none;
    color: vars.$blackColor;
    cursor: pointer;
    font-size: 1rem;
    padding: 0;
    transition: background-color 0.3s;

    &:hover {
        color: vars.$lightBlackColor;
        text-decoration: underline;
    }

    &.green {
        color: vars.$greenColor;

        &:hover {
            color: vars.$lightGreenColor;
        }
    }

    &.red {
        color: vars.$redColor;

        &:hover {
            color: vars.$lightRedColor;
        }
    }

    &.blue {
        color: vars.$blueColor;

        &:hover {
            color: vars.$lightBlueColor;
        }
    }

    &.white {
        color: vars.$whiteColor;

        &:hover {
            color: vars.$lightWhiteColor;
        }
    }

    &.attention {
        color: vars.$redColor;
        border: 1px solid vars.$redColor;
        font-weight: bold;
        padding: 10px;
        &:hover {
            color: white;
            background-color: vars.$redColor;
            text-decoration: none;
        }
    }
}
</style>
